import { useEffect } from 'react';
import { useStatsigClient } from '@statsig/react-bindings';

import {
  configureStatsigReplay,
  evaluateDynamicReplaySampling,
  registerStatsigReplayClient,
} from './statsig-service';

interface StatsigReplayInitializerProps {
  sdkKey: string;
  samplingGateName: string;
}

export function StatsigReplayInitializer({
  sdkKey,
  samplingGateName,
}: StatsigReplayInitializerProps): null {
  const { client } = useStatsigClient();

  useEffect(() => {
    configureStatsigReplay({ sdkKey, samplingGateName });
    registerStatsigReplayClient(client);

    if (client?.loadingStatus === 'Ready') {
      evaluateDynamicReplaySampling();
    }
  }, [client, client?.loadingStatus, sdkKey, samplingGateName]);

  return null;
}
